<template>
  <div class="appBody bg-white " v-title data-title="安丘专技教育-首页">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <div class="downAppImg position-fixed cursor-pointer bottom-5" v-if="isShowApp">
      <van-button @click="goDownPage" round type="info">APP内打开</van-button>
    </div>
    <index-header-nav></index-header-nav>
    <swipe-component v-if="slideList && slideList.length>0" :slidesList="slideList"></swipe-component>
    <yong-component v-if="trainingList && trainingList.length>0" :yongProList="trainingList"  title="培训动态"></yong-component>
    <yong-component v-if="noticeList && noticeList.length>0" :yongProList="noticeList"  title="通知公告"></yong-component>
    <yong-component v-if="regulationList && regulationList.length>0" :yongProList="regulationList"  title="政策法规"></yong-component>
    <zhuanlan-component v-if="hotList && hotList.length>0" :zhuanlanList="hotList" title="热门推荐"></zhuanlan-component>
    <zhuanlan-component v-if="lectureList && lectureList.length>0" :zhuanlanList="lectureList" title="公需课"></zhuanlan-component>
    <zhuanlan-component v-if="courseList && courseList.length>0" :zhuanlanList="courseList" title="专业课"></zhuanlan-component>
    <teacher-component v-if="teacherList && teacherList.length>0" :LecturersList=teacherList></teacher-component>
    <index-footer></index-footer>
  </div>
</template>

<script>
  import IndexHeaderNav from '@/page/home/components/indexHeaderNav'
  import SwipeComponent from '@/page/home/components/swipeComponent'
  import YongComponent from '@/page/home/components/yongComponent'
  import zhuanlanComponent from '@/page/home/components/zhuanlanComponent'
  import teacherComponent from '@/page/home/components/teacherComponent'
  import indexFooter from '@/page/home/components/indexFooter'

  import Vue from 'vue';
  import {Popup} from 'vant';
  import {Skeleton} from 'vant';
  import {Icon} from 'vant';

  Vue.use(Popup);
  Vue.use(Skeleton);
  Vue.use(Icon);

  export default {
    name: "indexPage",
    data() {
      return {
        slideList: [],
        noticeList: [],
        teacherList: [],
        courseList: [],
        lectureList: [],
        trainingList: [],
        regulationList: [],
        hotList: [],
        showPop: false,
        loadingPop: true,
        showShare: false,
        // shiyong: false,
        shareObj: {},
        isShowApp: false,

      }
    },
    components: {
      SwipeComponent,
      YongComponent,
      zhuanlanComponent,
      teacherComponent,
      indexFooter,
      IndexHeaderNav,
    },
    created() {
      this.browserRedirect();
    },
    mounted() {
      this.getHome();
    },
    methods: {
      getHome() {
        let categoryIds = ['home_teacher','home_training','home_notice','home_regulations','home_course','home_lecture','home_slide','home_hot'].join(',');
        this.$store.dispatch('getHome',{categoryIds: categoryIds}).then((res) => {
          if(res) {
            if(res['home_slide'] && res['home_slide'].length>0) {
              this.slideList = res['home_slide'].slice(0,4); // PC轮播图4
            }
            if(res['home_training'] && res['home_training'].length>0) {
              this.trainingList = res['home_training'].slice(0,6); // 培训动态6
            }
            if(res['home_notice'] && res['home_notice'].length>0) {
              this.noticeList = res['home_notice'].slice(0,5); // 通知公告5
            }
            if(res['home_regulations'] && res['home_regulations'].length>0) {
              this.regulationList = res['home_regulations'].slice(0,4); // 政策法规4
            }
            if(res['home_hot'] && res['home_hot'].length>0) {
              this.hotList = res['home_hot'].slice(0,2); // 热门培训2
            }
            if(res['home_course'] && res['home_course'].length>0) {
              this.courseList = res['home_course'].slice(0,4);// 专业课4
            }
            if(res['home_lecture'] && res['home_lecture'].length>0) {
              this.lectureList = res['home_lecture'].slice(0,4);// 公需课4
            }
            if(res['home_teacher'] && res['home_teacher'].length>0) {
              this.teacherList = res['home_teacher'].slice(0,4);// 师资团队4
            }

          }
        }).catch(e=>{console.log(e)});
      },
      goDownPage() {
        this.$router.push('/app/down');
      },
      //判断是PC端还是移动端
      browserRedirect() {

        if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          //跳转移动端页面
          this.isShowApp = true;
          return false;
        } else {
          //跳转pc端页面
          this.isShowApp = false;
          window.location.href = '//aqjsjx.com.cn/';
        }
      },
      showPopup() {
        // this.showPop = true;
        // this.loadingPop = false;
        this.$router.push('/login')
      },
      closepop(e) {
        this.showPop = e;
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'index';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>

<style scoped>
  #app {
    overflow: hidden;
  }

</style>
